import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './store';
import App from './App';
import './assets/styles/app.css';

function applyInitialTheme() {
  try {
    const raw = localStorage.getItem('persist:root')
    if (raw) {
      const persisted = JSON.parse(raw)
      const themeState = persisted.theme ? JSON.parse(persisted.theme) : null
      const mode = themeState?.mode
      const root = document.documentElement
      if (mode === 'dark') {
        root.classList.add('dark')
      } else {
        root.classList.remove('dark')
      }
      return
    }
  } catch (e) {
    // ignore
  }
  const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
  const root = document.documentElement
  if (prefersDark) {
    root.classList.add('dark')
  } else {
    root.classList.remove('dark')
  }
}

applyInitialTheme()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);